import Modal from "components/Modal";
import { FormProvider } from "react-hook-form";
import Divider from "components/Divider";
import {
  ModalPrimaryButton,
  ModalSecondaryAction,
} from "../../customer/AddFacility/AddFacilityModal";
import { RadioCardGroup } from "components/RadioCardGroup";
import { DatePickerNew } from "../../../../components/DatePickerNew";
import { useMemo } from "react";
import {
  UppdragScheduleDateType,
  uppdragScheduledDateAsString,
} from "types/uppdrag.type";
import { DropdownFormProvider } from "components/DropdownFormProvider";
import { TextAreaFormProvider } from "components/TextAreaFormProvider";
import { CreateOrUpdateUppdragLogicRetVal } from "./useCreateOrUpdateUppdragLogic";
import { TUppdragSchema } from "./uppdragSchema";
import { TextInputFormProvider } from "components/TextInputFormProvider";
import { CheckboxFormProvider } from "components/CheckboxFormProvider";

type Props = {
  logic: CreateOrUpdateUppdragLogicRetVal;
};
export const PatchUppdragModal = ({ logic }: Props) => {
  const scheduleDateType = logic.form.watch("scheduleDateType");
  const scheduleDateLabel = useMemo(() => {
    switch (scheduleDateType) {
      case UppdragScheduleDateType.Day:
        return "Datum";
      case UppdragScheduleDateType.Week:
        return "Vecka";
      case UppdragScheduleDateType.Month:
        return "Månad";
    }
  }, [scheduleDateType]);

  const dateCustomType = useMemo(() => {
    switch (scheduleDateType) {
      case UppdragScheduleDateType.Day:
        return "day";
      case UppdragScheduleDateType.Week:
        return "week";
      case UppdragScheduleDateType.Month:
        return "month";
    }
  }, [scheduleDateType]);

  return (
    <Modal
      isOpen={logic.isModalOpen}
      title={logic.modalTitle}
      actionText="Spara"
      onClose={logic.onModalClose}
      afterClose={logic.afterModalClose}
      isLoading={logic.mutation.isPending}
      loadingText="Sparar..."
      hideButtons
    >
      <FormProvider {...logic.form}>
        <form className="mt-4 pt-4" onSubmit={logic.onSubmit}>
          <h4 className="mb-4 text-sm font-bold text-gray-950">
            Schemalagt datum
          </h4>
          <div className="mt-2 grid grid-cols-1 gap-6 sm:grid-cols-1">
            <RadioCardGroup<TUppdragSchema>
              name="scheduleDateType"
              label="Precision"
              required
              items={[
                { id: "Day", label: "Datum" },
                { id: "Week", label: "Vecka" },
                { id: "Month", label: "Månad" },
              ]}
              className="col-span-1"
              radioGroupClassName="grid grid-cols-3 gap-x-2"
            />
            <DatePickerNew
              name="scheduleDate"
              label={scheduleDateLabel}
              placeholder={scheduleDateLabel}
              customType={dateCustomType}
              required
              useCustomInput
              customValue={uppdragScheduledDateAsString(
                logic.scheduleDateType as UppdragScheduleDateType,
                logic.scheduleDate,
              )}
            />
            <CheckboxFormProvider
              name="isPrioritized"
              label="Prioriterat uppdrag"
            />
          </div>

          <Divider className="mb-4 mt-6" />
          <DropdownFormProvider
            items={logic.userDropdownItems}
            label="Operatör"
            name="assignedToUserUuid"
            required
            className="mb-6"
            hideClearButton
          />
          <TextAreaFormProvider
            label="Uppdragsbeskrivning"
            name="description"
            rows={3}
            className="mb-6"
          />
          <TextInputFormProvider
            label="Referens"
            name="referenceNumber"
            className="mb-6"
          />

          <Divider className="mb-4 mt-6" />
          <div className="flex justify-end">
            <div className="flex w-full space-x-2">
              <ModalSecondaryAction onClick={logic.onModalClose} />
              <ModalPrimaryButton
                isLoading={logic.mutation.isPending}
                buttonText="Spara"
                loadingText="Sparar"
              />
            </div>
          </div>
        </form>
      </FormProvider>
    </Modal>
  );
};
